import { render, staticRenderFns } from "./type130.vue?vue&type=template&id=51718292&scoped=true"
import script from "./type130.vue?vue&type=script&lang=js"
export * from "./type130.vue?vue&type=script&lang=js"
import style0 from "./type130.vue?vue&type=style&index=0&id=51718292&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51718292",
  null
  
)

export default component.exports